import app from 'flarum/forum/app';
import { override } from 'flarum/common/extend';
let tagSelectionInstalled = false;
let followTagsInstalled = false;
let followRelation = null;
let followAllRefs = null;
const expandedParents = new Set();
function isSecondaryTag(tag) {
  return !!tag && typeof tag.position === 'function' && tag.position() === null;
}
function tagParent(tag) {
  if (!tag || typeof tag.parent !== 'function') {
    return null;
  }
  return tag.parent() || null;
}
function getFollowRelation() {
  return app.forum && app.forum.data && app.forum.data.relationships && app.forum.data.relationships.fofFollowTagsPromptList ? app.forum.data.relationships.fofFollowTagsPromptList : null;
}
function captureFollowTags() {
  const rel = getFollowRelation();
  if (!rel || !Array.isArray(rel.data)) {
    return null;
  }
  if (rel !== followRelation) {
    followRelation = rel;
    followAllRefs = rel.data.slice();
    expandedParents.clear();
  }
  return rel;
}
function usableFollowRefs() {
  if (!Array.isArray(followAllRefs)) {
    return [];
  }
  return followAllRefs.filter(ref => {
    if (!ref || !ref.id) return true;
    const tag = app.store.getById('tags', ref.id);
    return !tag || !isSecondaryTag(tag);
  });
}
function visibleFollowRefs() {
  return usableFollowRefs().filter(ref => {
    if (!ref || !ref.id) return true;
    const tag = app.store.getById('tags', ref.id);
    if (!tag) return true;
    const parent = tagParent(tag);
    if (!parent) {
      return true;
    }
    return expandedParents.has(String(parent.id()));
  });
}
function vnodeText(node) {
  if (node === null || node === undefined || node === false) {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(vnodeText).join('');
  }
  if (node.children) {
    return vnodeText(node.children);
  }
  return '';
}
function findTagNameCells(node, result) {
  if (result === void 0) {
    result = [];
  }
  if (!node) return result;
  if (Array.isArray(node)) {
    node.forEach(child => findTagNameCells(child, result));
    return result;
  }
  if (typeof node !== 'object') {
    return result;
  }
  if (node.tag === 'td' && node.attrs && String(node.attrs.className || '').split(/\s+/).includes('TagName')) {
    result.push(node);
  }
  if (node.children) {
    findTagNameCells(node.children, result);
  }
  return result;
}
function makeFollowParentsCollapsible(vnode) {
  const tagsByName = new Map();
  usableFollowRefs().forEach(ref => {
    if (!ref || !ref.id) return;
    const tag = app.store.getById('tags', ref.id);
    if (!tag || tagParent(tag)) return;
    tagsByName.set(tag.name(), tag);
  });
  findTagNameCells(vnode).forEach(cell => {
    const name = vnodeText(cell.children).trim();
    const tag = tagsByName.get(name);
    if (!tag) return;
    const id = String(tag.id());
    const opened = expandedParents.has(id);
    cell.attrs.className = String(cell.attrs.className || '') + ' val-follow-parent-toggle' + (opened ? ' val-follow-parent-toggle-open' : '');
    cell.attrs.title = opened ? 'Masquer les sous-rubriques' : 'Afficher les sous-rubriques';
    cell.attrs.onclick = () => {
      if (expandedParents.has(id)) {
        expandedParents.delete(id);
      } else {
        expandedParents.add(id);
      }
      m.redraw();
    };
  });
}
function installFilters() {
  if (!tagSelectionInstalled) {
    const TagSelectionModal = flarum.reg.get('flarum-tags', 'common/components/TagSelectionModal');
    if (TagSelectionModal) {
      override(TagSelectionModal.prototype, 'getFilteredTags', function (original) {
        for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
          args[_key - 1] = arguments[_key];
        }
        return original(...args).filter(tag => !isSecondaryTag(tag));
      });
      tagSelectionInstalled = true;
    }
  }
  if (!followTagsInstalled) {
    const ChooseTagsToFollowModal = flarum.reg.get('fof-follow-tags', 'forum/components/ChooseTagsToFollowModal');
    if (ChooseTagsToFollowModal) {
      override(ChooseTagsToFollowModal.prototype, 'content', function (original) {
        const rel = captureFollowTags();
        for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
          args[_key2 - 1] = arguments[_key2];
        }
        if (!rel) {
          return original(...args);
        }
        const saved = rel.data;
        rel.data = visibleFollowRefs();
        const vnode = original(...args);
        rel.data = saved;
        makeFollowParentsCollapsible(vnode);
        return vnode;
      });
      followTagsInstalled = true;
    }
  }
  if (tagSelectionInstalled || followTagsInstalled) {
    m.redraw();
  }
  return tagSelectionInstalled && followTagsInstalled;
}
app.initializers.add('val-ui-hide-secondary-tags', () => {
  installFilters();
  const timer = window.setInterval(() => {
    if (installFilters()) {
      window.clearInterval(timer);
    }
  }, 250);
});